"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _amsLogin = _interopRequireDefault(require("./ams-login"));

var _amsLogout = _interopRequireDefault(require("./ams-logout"));

var _amsProjectManagement = _interopRequireDefault(require("./ams-project-management"));

var _amsSignup = _interopRequireDefault(require("./ams-signup"));

var _amsResetPassword = _interopRequireDefault(require("./ams-reset-password"));

var _amsVerifyRequest = _interopRequireDefault(require("./ams-verify-request"));

var _amsProfile = _interopRequireDefault(require("./ams-profile"));

var _amsVerifyEmail = _interopRequireDefault(require("./ams-verify-email"));

var _amsSetPassword = _interopRequireDefault(require("./ams-set-password"));

var _amsAcceptInvite = _interopRequireDefault(require("./ams-accept-invite"));

var _amsDirectory = _interopRequireDefault(require("./ams-directory"));

var _amsUpdatePassword = _interopRequireDefault(require("./ams-update-password"));

var _amsRequests = _interopRequireDefault(require("./ams-requests"));

var _amsSendInvite = _interopRequireDefault(require("./ams-send-invite"));

var _amsUserSearch = _interopRequireDefault(require("./ams-user-search"));

var _amsAssignToProject = _interopRequireDefault(require("./ams-assign-to-project"));

var _amsCreateGroup = _interopRequireDefault(require("./ams-create-group"));

var _amsGroupsInProject = _interopRequireDefault(require("./ams-groups-in-project"));

var _amsUserPreferences = _interopRequireDefault(require("./ams-user-preferences"));

var _amsSlackPreferences = _interopRequireDefault(require("./ams-slack-preferences"));

var _amsMessages = _interopRequireDefault(require("./ams-messages"));

var _amsEmailPreferences = _interopRequireDefault(require("./ams-email-preferences"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  "ams-login": _amsLogin["default"],
  "ams-logout": _amsLogout["default"],
  "ams-project-management": _amsProjectManagement["default"],
  "ams-signup": _amsSignup["default"],
  "ams-reset-password": _amsResetPassword["default"],
  "ams-verify-request": _amsVerifyRequest["default"],
  "ams-profile": _amsProfile["default"],
  "ams-verify-email": _amsVerifyEmail["default"],
  "ams-set-password": _amsSetPassword["default"],
  "ams-accept-invite": _amsAcceptInvite["default"],
  "ams-directory": _amsDirectory["default"],
  "ams-update-password": _amsUpdatePassword["default"],
  "ams-requests": _amsRequests["default"],
  "ams-send-invite": _amsSendInvite["default"],
  "ams-user-search": _amsUserSearch["default"],
  "ams-assign-to-project": _amsAssignToProject["default"],
  "ams-create-group": _amsCreateGroup["default"],
  "ams-groups-in-project": _amsGroupsInProject["default"],
  "ams-user-preferences": _amsUserPreferences["default"],
  "ams-slack-preferences": _amsSlackPreferences["default"],
  "ams-messages": _amsMessages["default"],
  "ams-email-preferences": _amsEmailPreferences["default"]
};
exports["default"] = _default;